import { render, staticRenderFns } from "./BotBar.vue?vue&type=template&id=22224a41&scoped=true&"
import script from "./BotBar.vue?vue&type=script&lang=js&"
export * from "./BotBar.vue?vue&type=script&lang=js&"
import style0 from "./BotBar.vue?vue&type=style&index=0&id=22224a41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22224a41",
  null
  
)

export default component.exports